import React from 'react';
import { Calendar, Clock, Building2, Video, Plus, Search, Filter, ChevronDown, List, CalendarDays, Eye, Edit, Trash2, AlertCircle, CheckCircle, Loader, X, ChevronLeft, ChevronRight, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, Zap } from 'lucide-react';
import Button from '@/components/ui/Button';

const CalendarView = ({ 
currentMonth,
setCurrentMonth,
getDaysOfMonth,
getInterviewsForDate,
handleViewDetails
}) => {


return (
<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
<div className="flex items-center justify-between mb-6">
<h2 className="text-xl font-semibold text-gray-900">
{currentMonth.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
</h2>
<div className="flex gap-2">
<button
onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1))}
className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
>
<ChevronLeft className="w-5 h-5" />
</button>
<button
onClick={() => setCurrentMonth(new Date())}
className="px-4 py-2 hover:bg-gray-100 rounded-lg transition-colors text-sm font-medium"
>
Today
</button>
<button
onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1))}
className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
>
<ChevronRight className="w-5 h-5" />
</button>
</div>
</div>

<div className="grid grid-cols-7 gap-2">
{['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
<div key={day} className="text-center text-sm font-semibold text-gray-600 py-2">
{day}
</div>
))}

{getDaysOfMonth(currentMonth).map((day, index) => {
const dayInterviews = day ? getInterviewsForDate(day) : [];
const isToday = day && 
new Date().getDate() === day && 
new Date().getMonth() === currentMonth.getMonth() &&
new Date().getFullYear() === currentMonth.getFullYear();

return (
<div
key={index}
className={`min-h-[100px] border border-gray-200 rounded-lg p-2 ${
!day ? 'bg-gray-50' : 'bg-white hover:bg-gray-50'
} ${isToday ? 'ring-2 ring-blue-500' : ''}`}
>
{day && (
<>
<div className={`text-sm font-medium mb-1 ${isToday ? 'text-blue-600' : 'text-gray-900'}`}>
{day}
</div>
<div className="space-y-1">
{dayInterviews.map(interview => (
<div
key={interview.id}
className={`text-xs p-1 rounded cursor-pointer ${
interview.type === 'mock' 
? 'bg-purple-100 text-purple-800 hover:bg-purple-200' 
: 'bg-blue-100 text-blue-800 hover:bg-blue-200'
}`}
onClick={() => handleViewDetails(interview)}
>
<div className="font-medium truncate">{interview.time}</div>
<div className="truncate">{interview.jobTitle}</div>
</div>
))}
</div>
</>
)}
</div>
);
})}
</div>
</div>

);
};

export default CalendarView;